export class PersonModel {
  person_id: number;
  last_name: string;
  first_name: string;
  contact_no: string;
  email_address: string;
  address_1: string;
  city: string;
  state: string;
  zip: string;
  work_phone: string;
  image_id: number;

  constructor(
      person_id: number,
      last_name: string,
      first_name: string,
      contact_no: string,
      email_address: string,
      address_1: string,
      city: string,
      state: string,
      zip: string,
      work_phone: string,
      image_id: number
  ) {
      this.person_id = person_id;
      this.last_name = last_name;
      this.first_name = first_name;
      this.contact_no = contact_no;
      this.email_address = email_address;
      this.address_1 = address_1;
      this.city = city;
      this.state = state;
      this.zip = zip;
      this.work_phone = work_phone;
      this.image_id = image_id;
  }
}
